import { stateObj, actionObj } from "../const"

export default function reducer(state: stateObj, action: actionObj): stateObj {
    switch (action.type) {
        // case "set-audio":
        //     return Object.assign(state, { audio: action.payload })
        //     case "set-audioList":
        //     return Object.assign(state, { audioList: action.payload })
        case "set-urls":
         state.urls[0] !== action.payload &&  state.urls.unshift(action.payload)
        return  Object.assign(state, { urls: state.urls.slice(0 , 20) })
        case "set-auth" :
       if(state.token === action.payload.token) return state
        return {...state, ...action.payload}
       
        default:
            return state
    }
}